// extracted by mini-css-extract-plugin
module.exports = {"slideLeft":"navigation-module__slideLeft___2N290"};